import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import {axios, Dialog} from "./tools";
import {host} from "./config";
import {GetRequestParam,LZStringCompress,LZStringDecompress} from "./tools/index"
Vue.use(Router);

const router = new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            redirect: '/home',
        },

        {
            path: '/LandingPage',
            name: 'LandingPage',
            component: () => import(/* webpackChunkName: "task" */ './views/LandingPage.vue'),
            meta: {
                title: '0',
                rand: Math.random()
            }
        },
        {
            path: '/home',
            name: 'home',
            component: () => import(/* webpackChunkName: "home" */ './views/Home/Home.vue'),
            meta: {
                title: '147',
                requireAuth: true,
                rand: Math.random()
            }
        },
        {
            path: '/document',
            name: 'document',
            component: () => import(/* webpackChunkName: "document" */ './views/Document/Document.vue'),
            meta: {
                title: '127',
                requireAuth: true,
            }
        },
        {
            path: '/my',
            name: 'my',
            component: () => import(/* webpackChunkName: "my" */ './views/My/My.vue'),
            meta: {
                title: '43',
                requireAuth: true,
            }
        },
        {
            path: '/WithdrawIncome',
            name: 'WithdrawIncome',
            component: () => import(/* webpackChunkName: "WithdrawIncome" */ './views/WithdrawIncome/WithdrawIncome.vue'),
            meta: {
                title: '148',
                requireAuth: true,
            }
        },
        {
            path: '/ReferrerIncome',
            name: 'ReferrerIncome',
            component: () => import(/* webpackChunkName: "WithdrawIncome" */ './views/ReferrerIncome/ReferrerIncome.vue'),
            meta: {
                title: '36',
                requireAuth: true,
            }
        },
        {
            path: '/Mint',
            name: 'Mint',
            component: () => import(/* webpackChunkName: "WithdrawIncome" */ './views/Mint/Mint.vue'),
            meta: {
                title: '120',
                requireAuth: true,
            }
        },
        {
            path: '/Transfer',
            name: 'Transfer',
            component: () => import(/* webpackChunkName: "Transfer" */ './views/Transfer/Transfer.vue'),
            meta: {
                title: '149',
                requireAuth: true,
            }
        },
        {
            path: '/withdrawCFC/:tabIndex',
            name: 'withdrawCFC',
            component: () => import(/* webpackChunkName: "withdrawCFC" */ './views/withdrawCFC/withdrawCFC.vue'),
            meta: {
                title: '150',
                requireAuth: true,
            }
        },
        {
            path: '/aboutsUs',
            name: 'aboutsUs',
            component: () => import(/* webpackChunkName: "aboutsUs" */ './views/aboutsUs.vue'),
            meta: {
                title: '151',
                requireAuth: true,
            }
        },
        {
            path: '/community',
            name: 'community',
            component: () => import(/* webpackChunkName: "community" */ './views/community.vue'),
            meta: {
                title: '67',
                requireAuth: true,
            }
        },
        {
            path: '/TransactionRecord',
            name: 'TransactionRecord',
            component: () => import(/* webpackChunkName: "TransactionRecord" */ './views/TransactionRecord/TransactionRecord.vue'),
            meta: {
                title: '52',
                requireAuth: true,
            }
        },
        {
            path: '/inviteFriends',
            name: 'inviteFriends',
            component: () => import(/* webpackChunkName: "inviteFriends" */ './views/inviteFriends/inviteFriends.vue'),
            meta: {
                title: '8',
                requireAuth: true,
                rand: Math.random()
            }
        },
        {
            path: '/allFriends',
            name: 'allFriends',
            component: () => import(/* webpackChunkName: "allFriends" */ './views/allFriends.vue'),
            meta: {
                title: '152',
                requireAuth: true,
                rand: Math.random()
            }
        },
        {
            path: '/buyNFT',
            name: 'buyNFT',
            component: () => import(/* webpackChunkName: "buyNFT" */ './views/buyNFT/buyNFT.vue'),
            meta: {
                title: '9',
                requireAuth: true,
            }
        },
        {
            path: '/CFClist',
            name: 'CFClist',
            component: () => import(/* webpackChunkName: "buyNFT" */ './views/CFClist/CFClist.vue'),
            meta: {
                title: '114',
                requireAuth: true,
            }
        },
        {
            path: '/CustodyIncome',
            name: 'CustodyIncome',
            component: () => import(/* webpackChunkName: "buyNFT" */ './views/CustodyIncome/CustodyIncome.vue'),
            meta: {
                title: '85',
                requireAuth: true,
            }
        },
        {
            path: '/ReferralIncome/:tabIndex',
            name: 'ReferralIncome',
            component: () => import(/* webpackChunkName: "buyNFT" */ './views/ReferralIncome.vue'),
            meta: {
                title: '90',
                requireAuth: true,
            }
        },
        {
            path: '/TrusteeshipDetails',
            name: 'TrusteeshipDetails',
            component: () => import(/* webpackChunkName: "inviteFriends" */ './views/TrusteeshipDetails/TrusteeshipDetails.vue'),
            meta: {
                title: '153',
                requireAuth: true,
                rand: Math.random()
            }
        },
        {
            path: '/Twitter',
            name: 'Twitter',
            component: () => import(/* webpackChunkName: "inviteFriends" */ './views/Twitter/Twitter.vue'),
            meta: {
                title: '34',
                requireAuth: true,
                rand: Math.random()
            }
        },
        {
            path: '/Twitter/:id',
            name: 'TwitterInfo',
            component: () => import(/* webpackChunkName: "inviteFriends" */ './views/TwitterInfo/TwitterInfo.vue'),
            meta: {
                title: '34',
                requireAuth: true,
                rand: Math.random()
            }
        },
        {
            path: '/Gpt',
            name: 'Gpt',
            component: () => import(/* webpackChunkName: "inviteFriends" */ './views/Gpt/Gpt.vue'),
            meta: {
                title: '154',
                requireAuth: true,
                rand: Math.random()
            }
        },
    ]
});


router.beforeEach((to, from, next) => {
    // 在跳转前判断页面是否有缓存，如果有则清除
    // if (to.meta.clearCache) {
    //     console.log('to.meta.clearCache',to.meta.clearCache)
    //     sessionStorage.clear()
    // }
    // let parentAddress = GetRequestParam().parentAddress;
    // if (parentAddress){
    //     if (parentAddress.length > 42) {
    //         parentAddress = parentAddress.substr(0, 42);
    //     }
    //     window.sessionStorage.setItem('parentAddress', parentAddress)
    // }
    let parentAddressPass = GetRequestParam().pass;
    if (parentAddressPass){
        parentAddressPass = parentAddressPass.split('#/')[0];
        // console.log('Pass',parentAddressPass)
        parentAddressPass = LZStringDecompress(parentAddressPass)
        console.log('pa',parentAddressPass)
        window.sessionStorage.setItem('parentAddress', parentAddressPass)
    }
    if (to.path === '/') {
        next({
            path: '/home',
        });
    }
    // 检测资金密码
    if (to.matched.some((r) => r.meta.checkFundPass)) {
        axios({
            method: 'post',
            url: host + 'user/query_info',
            data: {
                uid: store.state.uid,
            },
        }).then(function (response) {
            if (response.data && response.data.code === 0) {
                if (response.data.data.fundPass === 0) {
                    Dialog.confirm({
                        title: '提示',
                        message: '请先设置资金密码'
                    }).then(() => {
                        next({
                            path: '/setPayPassword',
                        });
                    });
                }
            }
        });
    }
    //  检测是否登录
    if (to.matched.some((r) => r.meta.requireAuth)) {
        if (store.state.accounts.length > 0) {   //判断是否已经登录
            next();
        } else {
            // // 已经登录，第一次就你如页面，设置state
            // if (setUserLoginInfo()) {
            //     next();
            //     return
            // }
            // next();
            next({
                path: '/LandingPage',
                // query: {redirect: to.fullPath}   //登录成功后重定向到当前页面
            });

        }
    } else {
        next();
    }
});
export default router;
